import { Component, OnInit, Input, HostListener } from '@angular/core';
import * as d3 from 'd3';
@Component({
  selector: 'app-3d-bar-chart',
  templateUrl: './3d-bar-chart.component.html'
})
export class Bar3DChartComponent implements OnInit {
  Data: any;
  @Input() GraphData: any;
  chartContainer: any;
  viewData = [];
  barnumber = 4;
  currentPage = 1;
  totalPage: number;
  constructor() { }
  ngOnInit(): void {

  }
  ngAfterViewInit() {
    this.chartContainer = '#dualaxisbar';
    if (this.GraphData != undefined && this.GraphData != null && this.GraphData.length != 0) {
      var result = this.SortData(this.GraphData);
      this.LoadBarChart(result, this.chartContainer);
    }
  }
  ngOnChanges(){
    this.chartContainer = '#dualaxisbar';
    this.currentPage = 1;
    if (this.GraphData != undefined && this.GraphData != null && this.GraphData.length != 0) {
      var result = this.SortData(this.GraphData);
      this.LoadBarChart(result, this.chartContainer);
    }
  }

  LoadBarChart(bardata, chartContainer) {
    let that = this;
    d3.select(chartContainer).html("");
    let chartContainerwithoutHash = chartContainer.split('#')[1];
    //console.log(bardata);
    this.totalPage = Math.ceil(bardata.length / this.barnumber);
    this.viewData = bardata.slice((this.currentPage - 1) * this.barnumber, this.currentPage * this.barnumber);
    // set the dimensions and margins of the graph
    if (this.GraphData != undefined && this.GraphData != null && this.GraphData.length != 0) {
      var svgWidth = 300, svgHeight = 150;
      var margin = { top: 20, right: 50, bottom: 30, left: 40 },
        width = svgWidth - margin.left - margin.right,
        height = svgHeight - margin.top - margin.bottom;
    }
    else {
      var svgWidth = d3.select(chartContainer).node().offsetWidth, svgHeight = 350;
      var margin = { top: 20, right: 10, bottom: 50, left: 75 };
      var width = svgWidth - margin.left - margin.right;
      var height = svgHeight - margin.top - margin.bottom;
    }
    const xscale_bw = 10;
    const rx = xscale_bw / 2, ry = xscale_bw / 2;
    var color = ['#A260B7', '#E370B3', '#46BDF0', '#98BB56', '#AA6544', '#6FD9DD', '#5589BB', '#68C083'];

    var svg = d3.select(chartContainer).append("svg")
      .attr("width", svgWidth)
      .attr("height", svgHeight);

    svg.append("defs").append("clipPath")
      .attr("id", chartContainerwithoutHash + "_clip")
      .append("rect")
      .attr("width", width)
      .attr("height", height);

    const chart = svg.append('g')
      .attr("transform",
        "translate(" + margin.left + "," + margin.top + ")"
      );
    let maxDataY = d3.max(bardata, function (d) {
      return parseInt(d.Ticket_Count);
    });
    var yRange = d3.scaleLinear().range([height, 0]);
    var yScale = yRange.domain([0, maxDataY]);
    let yTicks = that.GenerateTicks(yRange, maxDataY);
    maxDataY = yTicks[yTicks.length - 1];
    yScale = yRange.domain([0, maxDataY]);

    let maxDataZ = d3.max(bardata, function (d) {
      return Math.round(d.Percentage);
    });
    var zRange = d3.scaleLinear().range([height, 0]);
    var zScale = zRange.domain([0, maxDataZ]);
    let zTicks = that.GenerateTicks(zRange, maxDataZ);
    maxDataZ = zTicks[zTicks.length - 1];
    zScale = zRange.domain([0, maxDataZ]);


    var yAxis = chart.append('g').attr("class", "yaxis").call(d3.axisLeft(yScale)
      //.tickFormat(d => (d >= 1000 ? ((d / 1000).toFixed(1) + 'k') : d))
      .tickFormat(d => {
        return (d > 1 || d == 0) ? `${d3.format("~s")(d)}` : d.toFixed(1);
      })
      .tickSize(-width)
      .tickPadding(10)
      .tickValues(that.GenerateTicks(yRange, maxDataY)));
    yAxis
      .selectAll('line')
      .attr('stroke', '#e6e6e6')
    yAxis
      .select('.domain')
      .style('opacity', 0);
    d3.select(chartContainer).selectAll('.yaxis text')
      .style('text-anchor', 'start');

    var zAxis = chart.append('g')
      .attr("transform", "translate( " + width + ", 0 )")
      .attr("class", "zaxis").call(d3.axisRight(zScale)
        //.tickFormat(d => (d >= 1000 ? ((d / 1000).toFixed(1) + 'k') : d))
        .tickFormat(d => {
          return (d > 1 || d == 0) ? `${d3.format("~s")(d)}` : d.toFixed(1);
        })
        //.tickSize(-width)
        .tickPadding(10)
        .tickValues(that.GenerateTicks(zRange, maxDataZ)));
    zAxis
      .selectAll('line')
      .attr('stroke', '#e6e6e6')
    zAxis
      .select('.domain')
      .style('opacity', 0);
    d3.select(chartContainer).selectAll('.zaxis text')
      .style('text-anchor', 'start');

    var xScale = d3.scaleBand().range([0, width]).domain(this.viewData.map((d) => d.Column)).round(true).padding(0.36);

    var xAxis = chart.append('g')
      .attr('transform', `translate(0, ${height})`)
      .attr("class", "xaxis")
      .call(d3.axisBottom(xScale).tickPadding(5).tickSize(10, 10));
    xAxis
      .selectAll('line')
      .attr('stroke', '#e6e6e6')
    xAxis
      .select('.domain')
      .style('opacity', 0);

    //Show the x axis labels in 45 degree and show only alternate labels in case if more than 20 x axis labels are there
    d3.select(chartContainer).selectAll('.xaxis text')
      .attr("x", 0)
      //.style("text-anchor", bardata.length > 6 ? "end" : "")
      .style("text-anchor", "middle")
      .attr('class', function (d, i) { if (that.viewData.length > 20 && i % 2 != 0) { d3.select(this).remove(); } })
      //.attr("transform", bardata.length > 6 ? "rotate(-45)" : "");
      //.attr("transform", "rotate(-45)")
      .text(d => {
        if (d.length > 10) {
          d = d.substring(0, 7) + '...';
        }
        return d;
      })
      .append('title')
      .text(d => d); //d.length > 12 ? d : null);

    xAxis.selectAll('text')
      .style('text-anchor', 'middle')
      .attr("font-family", "Graphik Regular")
      .attr("font-size", "10px")
      .style('white-space', 'nowrap')
      .style('cursor', 'default')
      .attr('y', '10')
      //.attr('dy', '0.71em')
      .attr('x', '0')
      //.attr('transform', d => 'rotate(-45)')
      .append('title')
      //.text(d => d.length > 7 ? d : null);
      .text(d => "ColumnName");

    //Drawing 1st Column chart 
    var barGroups = chart
      .append('g')
      .attr("clip-path", "url(#" + chartContainerwithoutHash + "_clip)")
      .selectAll()
      .data(this.viewData)
      .enter()
      .append('g')

    var columns = barGroups
      .append('path')
      .attr('class', 'column')
      .attr("d", d => `
    M${xScale(d.Column) + xScale.bandwidth() / 2 - rx},${yScale(d.Ticket_Count) + ry}
    a${rx},${ry} 0 0 1 ${rx},${-ry}
    h${xscale_bw - 2 * rx}
    a${rx},${ry} 0 0 1 ${rx},${ry}
    v${height - yScale(d.Ticket_Count) - ry}
    h${-(xscale_bw)}Z
  `)
      .attr('fill', '#A260B7');
    // chart
    //   .append('g')
    //   .selectAll()
    //   .data(this.viewData)
    //   .enter()
    //   .append("text")
    //   .attr("text-anchor", "middle")
    //   .attr("y", d => yScale(d.Ticket_Count) - 5)
    //   .attr("x", (d, i) => xScale(d.Column) + xScale.bandwidth() / 2 - rx + 14)
    //   .attr("font-size", "8px")
    //   .style("fill", "black")
    //   .attr("font-family", "Graphik SemiBold")
    //   .text((d, i) => {
    //     return that.CleanNumber(d.Ticket_Count);
    //   });

    var columnsdual = barGroups
      .append('path')
      .attr('class', 'column')
      .attr("d", d => `
M${xScale(d.Column) + xScale.bandwidth() / 2 + rx},${zScale(d.Percentage) + ry}
a${rx},${ry} 0 0 1 ${rx},${-ry}
h${xscale_bw - 2 * rx}
a${rx},${ry} 0 0 1 ${rx},${ry}
v${height - zScale(d.Percentage) - ry}
h${-(xscale_bw)}Z
`)
      .attr('fill', '#67B7DC');
    // chart
    //   .append('g')
    //   .selectAll()
    //   .data(this.viewData)
    //   .enter()
    //   .append("text")
    //   .attr("text-anchor", "middle")
    //   .attr("y", d => yScale(d.Percentage) - 5)
    //   .attr("x", (d, i) => xScale(d.Column) + xScale.bandwidth() / 2 - rx + 14)
    //   .attr("font-size", "8px")
    //   .style("fill", "black")
    //   .attr("font-family", "Graphik SemiBold")
    //   .text((d, i) => {
    //     return that.CleanNumber(d.Percentage);
    //   });

    columns.on('mouseover', function (d, i) {
      d3.select(this).style("fill", "#A260B7");
      d3.select(this).style('cursor', 'pointer');
      var tooltip = svg
        .append("g")
        .style("cursor", "pointer")
        .attr("class", "tooltip")
        .style("opacity", 1)
      tooltip.append("rect")
        .attr("width", 90)
        .attr('height', 40)
        .style('fill', '#FFFFFF')
        .style('pointer-events', 'none')
        .style('stroke', d3.select(this).style('fill'))
        .style('stroke-width', 2)
        .style('fill-opacity', 0.8);
      var textSvg = tooltip.append("text")
        .attr('x', 7)
        .attr('y', 15)
        .style('pointer-events', 'none')
        .style('fill', '#333333')
        .style('font-size', '12px')
        .style('color', '#333333');
      textSvg.append("tspan")
        .style('font-size', '11px')
        .style('pointer-events', 'none')
        .style('font-family', 'Graphik Regular')
        .style('font-weight', 'bold')
        .text(d3.select(this).data()[0].Column)
      textSvg.append("tspan")
        .attr('x', 7)
        .attr('dy', 15)
        .style('pointer-events', 'none')
        .style('fill', d3.select(this).style('fill'))
        .html('&#x25cf')
      textSvg.append("tspan")
        .attr('dx', 0)
        .style('pointer-events', 'none')
        .style('font-size', '11px')
        .style('font-family', 'Graphik Regular')
        .style('font-weight', 'bold')
        .text(d3.select(this).data()[0].XAxis + " : ")
        .style('font-weight', 'bold')
      textSvg.append("tspan")
        .attr('dx', 0)
        .style('pointer-events', 'none')
        .style('font-family', 'Graphik Regular')
        .style('font-weight', 'bold')
        .text(d3.format(',')(parseInt(d3.select(this).data()[0].Ticket_Count)));
    })
      .on("mousemove", function (d, i) {
        d3.select(this).style("fill", "#A260B7");
        d3.select(this).style('cursor', 'pointer');
        var mousePosition = d3.mouse(this);
        var x = mousePosition[0];
        var y = mousePosition[1];
        var text = d3.select(this.closest('svg')).select('.tooltip text');
        var bbox = text.node().getBBox();
        d3.select(this.closest('svg'))
          .select('.tooltip rect')
          .attr("width", bbox.width + 15)
        if (x - bbox.width / 2 < 0) {
          x = bbox.width / 2;
        }
        else if (width - x - bbox.width / 2 < 0) {
          x = width - bbox.width / 2;
        }
        if (y - bbox.height / 2 < 0) {
          y = bbox.height * 2;
        }
        else if (height - y - bbox.height / 2 < 0) {
          y = height - bbox.height / 2;
        }
        d3.select(this.closest('svg'))
          .select('.tooltip')
          .style("opacity", 1)
          .attr('transform', `translate(${x + 10}, ${y - 20})`);
      })
      .on("mouseout", function (d, i) {
        d3.select(this).style("fill", "#A260B7");
        d3.select(this.closest('svg'))
          .select('.tooltip').style('display', 'none');
        d3.select(this.closest('svg'))
          .select(".tooltip").remove();
        d3.select(this)
          .style("opacity", 1);
      });


    columnsdual.on('mouseover', function (d, i) {
      d3.select(this).style("fill", "#67B7DC");
      d3.select(this).style('cursor', 'pointer');
      var tooltip = svg
        .append("g")
        .style("cursor", "pointer")
        .attr("class", "tooltip")
        .style("opacity", 1)
      tooltip.append("rect")
        .attr("width", 90)
        .attr('height', 40)
        .style('fill', '#FFFFFF')
        .style('pointer-events', 'none')
        .style('stroke', d3.select(this).style('fill'))
        .style('stroke-width', 2)
        .style('fill-opacity', 0.8);
      var textSvg = tooltip.append("text")
        .attr('x', 7)
        .attr('y', 15)
        .style('pointer-events', 'none')
        .style('fill', '#333333')
        .style('font-size', '12px')
        .style('color', '#333333');
      textSvg.append("tspan")
        .style('font-size', '11px')
        .style('pointer-events', 'none')
        .style('font-family', 'Graphik Regular')
        .style('font-weight', 'bold')
        .text(d3.select(this).data()[0].Column)
      textSvg.append("tspan")
        .attr('x', 7)
        .attr('dy', 15)
        .style('pointer-events', 'none')
        .style('fill', d3.select(this).style('fill'))
        .html('&#x25cf')
      textSvg.append("tspan")
        .attr('dx', 0)
        .style('pointer-events', 'none')
        .style('font-size', '11px')
        .style('font-family', 'Graphik Regular')
        .style('font-weight', 'bold')
        .text(d3.select(this).data()[0].zAxis + " : ")
        .style('font-weight', 'bold')
      textSvg.append("tspan")
        .attr('dx', 0)
        .style('pointer-events', 'none')
        .style('font-family', 'Graphik Regular')
        .style('font-weight', 'bold')
        .text(d3.format(',')(Math.round(d3.select(this).data()[0].Percentage)));

    })
      .on("mousemove", function (d, i) {
        d3.select(this).style("fill", "#67B7DC");
        d3.select(this).style('cursor', 'pointer');
        var mousePosition = d3.mouse(this);
        var x = mousePosition[0];
        var y = mousePosition[1];
        var text = d3.select(this.closest('svg')).select('.tooltip text');

        var bbox = text.node().getBBox();
        d3.select(this.closest('svg'))
          .select('.tooltip rect')
          .attr("width", bbox.width + 15)
        if (x - bbox.width / 2 < 0) {
          x = bbox.width / 2;
        }
        else if (width - x - bbox.width / 2 < 0) {
          x = width - bbox.width / 2;
        }
        if (y - bbox.height / 2 < 0) {
          y = bbox.height * 2;
        }
        else if (height - y - bbox.height / 2 < 0) {
          y = height - bbox.height / 2;
        }
        d3.select(this.closest('svg'))
          .select('.tooltip')
          .style("opacity", 1)
          .attr('transform', `translate(${x + 10}, ${y - 20})`);
      })
      .on("mouseout", function (d, i) {
        d3.select(this).style("fill", "#67B7DC");
        d3.select(this.closest('svg'))
          .select('.tooltip').style('display', 'none');
        d3.select(this.closest('svg'))
          .select(".tooltip").remove();
        d3.select(this)
          .style("opacity", 1);
      });

    //Y Axis legend
    svg.append('text')
      .attr('x', -(height / 2))
      .attr('y', 1)
      .attr("dy", "1em")
      .attr("font-family", "Graphik Regular")
      .attr('transform', 'rotate(-90)')
      .style('fill', '#015b63')
      .style('font-size', '12px')
      .style('font-weight', 'bold')
      .attr('text-anchor', 'middle')
      .text(this.viewData[0].XAxis);

    //X Axis legend
    // svg.append("rect")
    //   .attr("x", (svgWidth / 2) - 20)
    //   .attr("y", svgHeight - margin.top - 10)
    //   .attr('height', 12)
    //   .attr('width', 12)
    //   .attr('rx', 6)
    //   .attr('ry', 6)
    //   .style('fill', '#A260B7')
    //   .style('cursor', 'default')
    //   .style('top', margin.top)
    //   .attr('text-anchor', 'end');

    svg.append('text')
      .attr('x', (svgWidth / 2))
      .attr('y', svgHeight - margin.top)
      .style('fill', '#015b63')
      .style('cursor', 'pointer')
      .style('font-size', '12px')
      .style('font-weight', 'bold')
      .attr('text-anchor', 'start')
      //.text(this.viewData[0].XAxis);
      .text(this.viewData[0].yaxis);

    //Pagination
    if (this.totalPage > 1) {
      svg.append("path")
        .attr("d", "M3.875,3.095,6.8.163a.551.551,0,0,1,.782,0,.558.558,0,0,1,0,.784L4.267,4.269a.553.553,0,0,1-.763.016L.161.949A.554.554,0,0,1,.943.165Z")
        .attr('transform', "translate(" + (margin.left - 10) + ", " + (svgHeight - margin.bottom + 9) + ") rotate(90)")     //19 (Because tickpadding=8 + margin from insertLineBreak=10 + 1(MagicNumber))
        .attr('class', 'leftTriangle')
        .attr('fill', '#000')
        .attr('stroke', '#000')
        .attr('stroke-width', 2)
        .attr("opacity", 0.7)
        .attr('cursor', 'pointer')
        .on('click', function (d) {
          if (that.currentPage != 1) {
            that.currentPage--;
            that.prevPage();
          }
        })
      svg.append("path")
        .attr("d", "M3.875,1.335,6.8,4.267a.551.551,0,0,0,.782,0,.558.558,0,0,0,0-.784L4.267.161A.553.553,0,0,0,3.5.145L.161,3.481a.554.554,0,0,0,.782.784Z")
        .attr('transform', "translate(" + (svgWidth - margin.right - 1) + ", " + (svgHeight - margin.bottom + 9) + ") rotate(90)")
        .attr('class', 'rightTriangle')
        .attr('fill', '#000')
        .attr('stroke', '#000')
        .attr('stroke-width', 2)
        .attr("opacity", 0.7)
        .style('cursor', 'pointer')
        .on('click', function (d) {
          if (that.currentPage < that.totalPage) {
            that.currentPage++;
            that.nextPage();
          }
        })

      if (that.currentPage == 1) {
        svg.select(".leftTriangle").attr('fill', '#cccccc').attr('stroke', '#cccccc').attr('stroke-width', 2).attr("opacity", 0.7).style('cursor', 'default');
      }
      if (that.currentPage == that.totalPage) {
        svg.select(".rightTriangle").attr('fill', '#cccccc').attr('stroke', '#cccccc').attr('stroke-width', 2).attr("opacity", 0.7).style('cursor', 'default');
      }
    }
  }

  /*generic way */
  nextPage() {
    var result = this.SortData(this.GraphData);
    this.LoadBarChart(result, this.chartContainer);
  }

  prevPage() {
    var result = this.SortData(this.GraphData);
    this.LoadBarChart(result, this.chartContainer);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    var result = this.SortData(this.GraphData);
    this.LoadBarChart(result, this.chartContainer);
  }
  GenerateTicks(axisRange, maxData) {
    let tickArray = axisRange.ticks(4);
    if (tickArray[tickArray.length - 1] < maxData) {
      let diff = (tickArray[tickArray.length - 1]) - (tickArray[tickArray.length - 2]);
      tickArray.push(tickArray[tickArray.length - 1] + diff);
    }
    return tickArray;
  }
  isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }
  CleanNumber(str) {
    if (str != 0)
      str = str.toFixed(2);
    if (str >= 1)
      str = d3.format("~s")(str);
    else
      str = str;
    if (!this.isNumeric(str)) {
      let lastLetter = str.substring(str.length - 1);
      str = str.substring(0, str.length - 1);
      if (str.indexOf('.'))
        str = parseFloat(str).toFixed(1).toString() + lastLetter;
    }
    return str;
  }
  SortData(inputData) {
    let result = [];
    let that = this;
    inputData.forEach(element => {
      result.push({ Column: element.Column, Percentage: element.Percentage, Ticket_Count: element.Ticket_Count, XAxis: element.XAxis, yAxis: element.yAxis, zAxis: element.zAxis, date: that.GetDate(element.Column) });
    });
    return result.sort((c, d) => c.date - d.date);
  }
  FindMonthIndex(month) {
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return (months.findIndex(x => x == month) + 1);
  }
  GetDate(data) {
    var month = this.FindMonthIndex(data.split("'")[0]);
    if (month > 0) {
      var year = parseInt('20' + data.split("'")[1]);
      return new Date(year, month, 1, 0, 0, 0, 0);
    }
    return '';
  }
}
